import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6cb2757e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6cb2757e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2757e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb2757e')) {
      api.createRecord('6cb2757e', component.options)
    } else {
      api.reload('6cb2757e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6cb2757e&scoped=true", function () {
      api.rerender('6cb2757e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/panorama-custom/index.vue"
export default component.exports